"use client";

import { useMemo, useState } from "react";
import Typography from "@mui/material/Typography";

import { DialogWithExit } from "@/src/component/base/DialogWithExit";
import { ProviderHooks } from "@/src/hook";
import { ComponentType, StrapiComponentType } from "@/src/type";

import SectionModule from "../../../../partial/__module__/SectionModule/SectionModule";
import AvailableHomesFiltersOptions from "./AvailableHomesFiltersOptions";

import styles from "./AvailableHomesFilters.module.scss";
import { Button } from "@mui/material";
import cn from "classnames";

import { AvailableHomesFiltersEmpty } from "./AvailableHomesFiltersEmpty";

interface AvailableHomesFiltersProps extends ComponentType.DynamicPageSectionComponentProps<StrapiComponentType.Section.AvailableHomesFilters> {}

function AvailableHomesFilters({
  section,
  slug,
  snapToGrid,
  lazy,
  searchParams,
  quality,
  mobileHint,
  deviceWidthHint,
  layout,
}: AvailableHomesFiltersProps) {
  const { clearFilters, homesCount } = ProviderHooks.useProperty();
  const [openFilters, setOpenFilters] = useState<boolean>(false);
  const availableHomesFilters: StrapiComponentType.Section.AvailableHomesFilters = section.type?.[0];
  const sectionRegistered = (Object.values(homesCount ?? {}) ?? []).length > 0;
  const isEmpty = useMemo(() => sectionRegistered && Object.values(homesCount ?? {}).every((count) => count === 0), [homesCount, sectionRegistered]);

  return (
    <SectionModule
      section={section}
      slug={slug}
      snapToGrid={snapToGrid}
      lazy={lazy}
      styleContainerId={availableHomesFilters.id}
      searchParams={searchParams}
      mobileHint={mobileHint}
      deviceWidthHint={deviceWidthHint}
      quality={quality}
      stylePrefix="AvailableHomesFilters"
      layout={layout}
      classes={{
        styledContainer: cn(styles.container, styles.sectionContainer),
      }}
    >
      <AvailableHomesFiltersOptions
        availableHomesFilters={availableHomesFilters}
        isDialog={false}
        openDialog={() => setOpenFilters(true)}
      />
      {isEmpty && <AvailableHomesFiltersEmpty onClearFilters={clearFilters} />}
      <DialogWithExit
        onExit={() => setOpenFilters(false)}
        dialogProps={{
          open: openFilters,
          onClose: () => setOpenFilters(false),
        }}
      >
        <div className={styles.dialogContainer}>
          <Typography className={styles.dialogTitle}>Preferences</Typography>
          <div className={styles.dialogContent}>
            <AvailableHomesFiltersOptions
              availableHomesFilters={availableHomesFilters}
              isDialog={true}
              openDialog={() => setOpenFilters(true)}
            />
          </div>
          <div className={styles.dialogFooter}>
            <Button
              variant="outlined"
              color="primary"
              onClick={() => clearFilters()}
            >
              Clear
            </Button>
            <Button
              variant="outlined"
              color="primary"
              onClick={() => setOpenFilters(false)}
            >
              Apply
            </Button>
          </div>
        </div>
      </DialogWithExit>
    </SectionModule>
  );
}

export default AvailableHomesFilters;
